// "7 placements · 14 images" and the handful of thumbnails a campaign row
// shows — derived from the campaign's own nested placements/instances, no
// extra API calls.
import type { ClubhouseAdKitDto } from "entities/responses/adkit";

export interface CampaignSummary {
  placementCount: number;
  imageCount: number;
}

export function summarizeCampaign(
  campaign: Pick<ClubhouseAdKitDto, "adLocations">,
): CampaignSummary {
  const locations = campaign.adLocations ?? [];
  const imageIds = new Set<string>();
  for (const location of locations) {
    for (const instance of location.adInstances ?? []) {
      imageIds.add(String(instance.imageId));
    }
  }
  return { placementCount: locations.length, imageCount: imageIds.size };
}

/** Up to `limit` distinct image URLs, in placement order, for the row's thumbnails. */
export function getPreviewImageUrls(
  campaign: Pick<ClubhouseAdKitDto, "adLocations">,
  limit = 3,
): string[] {
  const urls: string[] = [];
  for (const location of campaign.adLocations ?? []) {
    for (const instance of location.adInstances ?? []) {
      if (urls.length >= limit) return urls;
      if (!urls.includes(instance.imageUrl)) urls.push(instance.imageUrl);
    }
  }
  return urls;
}
